/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, September 22nd 2021, 11:44:01 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Grid from "@mui/material/Grid";

export function OneColGridContainer(props) {
  // TODO: Equivalent to as Stack so remove this
  return (
    <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 1, md: 1 }}>
      {props.children}
    </Grid>
  );
}

export const OneColGridItem = (props) => {
  // TODO: Equivalent to as Stack item so remove this
  return (
    <Grid item xs={1} md={1} key={props.key}>
      {props.children}
    </Grid>
  );
};

export function Responsive2ColGridContainer(props) {
  // Default columns are 12
  return (
    <Grid container spacing={{ xs: 1, md: 2 }}>
      {props.children}
    </Grid>
  );
}

export const Responsive2ColGridItem = (props) => {
  //Size of item as per default columns of 12
  return (
    <Grid item xs={12} sm={12} md={6} key={props.key}>
      {props.children}
    </Grid>
  );
};

export function Responsive3ColGridContainer(props) {
  return (
    <Grid container spacing={{ xs: 1, md: 2 }}>
      {props.children}
    </Grid>
  );
}

export const Responsive3ColGridItem = (props) => {
  return (
    <Grid item xs={12} sm={12} md={4} key={props.key}>
      {props.children}
    </Grid>
  );
};

export function Responsive4ColGridContainer(props) {
  return (
    <Grid container spacing={{ xs: 1, md: 2 }}>
      {props.children}
    </Grid>
  );
}

export const Responsive4ColGridItem = (props) => {
  return (
    <Grid item xs={12} sm={12} md={3} key={props.key}>
      {props.children}
    </Grid>
  );
};
